import { Posts } from '@/models/posts';

const LOGO_PREFIX = 'logo:';

export const toLogoKeyword = (brand: string): string =>
  `${LOGO_PREFIX}${brand}`;

export const isLogoKeyword = (keyword: string): boolean =>
  keyword.startsWith(LOGO_PREFIX);

export const toPlainKeyword = (keyword: string): string =>
  isLogoKeyword(keyword) ? keyword.slice(LOGO_PREFIX.length) : keyword;

export const isVideoLogoItem = (
  item: Posts.VideoLogoItem | Posts.LogoItem
): item is Posts.VideoLogoItem => 'logoFound' in item;

export const extractBrandNames = (
  groups: Array<Posts.VideoLogoItem | Posts.LogoItem>[]
): string[] => {
  const logoItems: Posts.LogoItem[] = groups
    .flat()
    .flatMap((item) => (isVideoLogoItem(item) ? item.logoFound : [item]));

  const brands = logoItems
    .map((logo) => logo?.content?.brand)
    .filter((brand): brand is string => Boolean(brand));

  return brands.filter((brand, index) => brands.indexOf(brand) === index);
};

export const getLogosFound = (
  obj: Posts.VideoLogoItem | Posts.LogoItem
): Posts.LogoItem[] => (isVideoLogoItem(obj) ? obj.logoFound : [obj]);
